module.exports = __webpack_public_path__ + "static/media/left-hand-moving.d8a7ccdb.png";